import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import { useSnackbar } from 'notistack';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import logo from '../../assets/img/logo.svg';
import portadaloggin from '../../assets/img/portadaloggin.png'
import { useDispatch } from 'react-redux'
import { loggin } from '../../Redux/Users';
import useSubmitLock from '../../hooks/useSubmitLock';
const { REACT_APP_API_URL } = process.env;


function Copyright(props) {
    return (<>
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://www.plant-for-the-planet.org/es/">
                Plant-for-the-planet
            </Link>{' '}
            {new Date().getFullYear()}
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center">
            Desarrollado por  <Link color="inherit" href="https://datwer.com/">DATWER</Link>
        </Typography></>
    );
}

const theme = createTheme();



export default function LogginUser() {

    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const { submitting, runWithSubmitLock } = useSubmitLock();

    const handleClickVariant = (resultado) => {
        const variant = resultado.variant
        const msg = resultado.errores || resultado.msg
        // variant could be success, error, warning, info, or default
        enqueueSnackbar(msg, { variant });
        if (variant === 'success') {
            dispatch(loggin(resultado))
            window.location.reload()
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        runWithSubmitLock(async () => {
        const data = new FormData(event.currentTarget);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("email", data.get('email'));
        urlencoded.append("password", data.get('password'));

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        try {
            const response = await fetch(`${REACT_APP_API_URL}/login`, requestOptions)
            const resultado = await response.json();
            return (handleClickVariant(resultado))
        } catch (error) {
            console.log('Algo salio mal', error);
        }
        })
    }

    return (
        <ThemeProvider theme={theme}>
            <Grid container component="main" sx={{ height: '100vh' }}>
                <CssBaseline />


                <Grid item xs={12} sm={8} md={4} component={Paper} elevation={6} square>
                    <Box
                        sx={{
                            my: 5,
                            mx: 5
                        }}
                        padding='10px'>
                        <img src={logo} alt="logo" />
                    </Box>

                    <Box
                        sx={{
                            my: 8,
                            mx: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >

                        <Avatar sx={{ m: 1, bgcolor: 'success.main' }}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            Iniciar sesion
                        </Typography>
                        <Box component="form" Validate onSubmit={handleSubmit} sx={{ mt: 1 }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Dirrección de correo electrónico"
                                name="email"
                                autoComplete="email"
                                autoFocus
                            />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Contraseña"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                            />

                            <Button
                                type="submit"
                                color='success'
                                fullWidth
                                variant="contained"
                                disabled={submitting}
                                sx={{ mt: 3, mb: 2 }}
                            >
                                Entrar
                            </Button>
                            <Copyright sx={{ mt: 5 }} />
                        </Box>
                    </Box>
                </Grid>
                <Grid
                    item
                    xs={false}
                    sm={4}
                    md={8}
                    sx={{
                        backgroundImage: `url(${portadaloggin})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: (t) =>
                            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}
                />
            </Grid>
        </ThemeProvider>
    );
}